export default {
  validate(value: any) {
    return typeof value === 'string';
  },
};
